<template>
    <v-dialog v-model="internalVisible" max-width="640" persistent>
        <v-card class="confirm-modal">
            <v-card-title class="headline title">Внимание!</v-card-title>
            <v-card-text class="body">
                <p>
                    Вы точно хотите отвязать эти услуги?
                    Это действие затронет все выбранные услуги и не может быть отменено!
                </p>
                <p>
                    Если у услуги больше не привязаны ни к одной группе/подгруппе, то они попадут в «{{ techGroupName }}» пока вы снова не привяжете их
                    к одной из групп/подгрупп.
                </p>
            </v-card-text>
            <v-card-actions class="actions">
                <v-btn color="#EE3939" class="confirm-btn" depressed @click="confirm">
                    <v-icon left>mdi-close</v-icon>
                    Подтвердить
                </v-btn>
                <v-btn class="cancel-btn" depressed @click="cancel">Отмена</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ConfirmTechTagModal',
    props: {
        value: { type: Boolean, default: false },
        techGroupName: { type: String, default: '' },
    },
    data: () => ({
        internalVisible: false,
    }),
    watch: {
        value: {
            immediate: true,
            handler(v) { this.internalVisible = v },
        },
        internalVisible(v) {
            this.$emit('input', v)
        },
    },
    methods: {
        confirm() {
            this.$emit('confirm')
            this.internalVisible = false
        },
        cancel() {
            this.internalVisible = false
            this.$emit('cancel')
        },
    },
}
</script>

<style lang="sass" scoped>
.confirm-modal
    display: flex
    flex-direction: column
    padding: 24px 16px 16px 16px
    gap: 24px
    .title
        color: #EE3939
        font-size: 18px
        font-weight: 700
        line-height: 16px
        letter-spacing: -0.54px
        padding: 0 !important
    .body
        color: #2A3B51
        padding: 0 !important
        display: flex
        flex-direction: column
        gap: 8px
        p
            margin: 0
    .actions
        display: flex
        gap: 12px
        padding: 0
    .confirm-btn
        color: #fff !important
        background: #EE3939 !important
    .cancel-btn
        color: #556274 !important
        background: transparent !important
        border: 1px solid #556274
</style>


